module.exports = __webpack_public_path__ + "static/media/pinterest.5cac3297.svg";